import { Contact } from '../_classes/list/contact';

export let Contacts: Contact[] = [
  {
    id: 1,
    client_id: 11,
    type_id: 2,
    type: 'Email',
    name: 'rob_t@mail.ru',
    comment: null,
    user_id: 11,
    user: 'A.В. Петров',
    dt: null,
    userm_id: 11,
    userm: 'A.В. Петров',
    dtm: null
  },
  {
    id: 2,
    client_id: 11,
    type_id: 2,
    type: 'Email',
    name: 'opo_usr@mail.ru',
    comment: null,
    user_id: 11,
    user: 'A.В. Петров',
    dt: null,
    userm_id: 11,
    userm: 'A.В. Петров',
    dtm: null
  },
  {
    id: 3,
    client_id: 11,
    type_id: 1,
    type: 'Телефон',
    name: '729-82-23',
    comment: null,
    user_id: 12,
    user: 'A.В. Сидоров',
    dt: null,
    userm_id: 12,
    userm: 'A.В. Сидоров',
    dtm: null
  },
  {
    id: 4,
    client_id: 12,
    type_id: 1,
    type: 'Телефон',
    name: '729-82-12',
    comment: null,
    user_id: 13,
    user: 'Ж.В. Кузнецова',
    dt: null,
    userm_id: 13,
    userm: 'Ж.В. Кузнецова',
    dtm: null
  },
  {
    id: 5,
    client_id: 13,
    type_id: 1,
    type: 'Телефон',
    name: '729-82-32',
    comment: null,
    user_id: 12,
    user: 'П.В. Яковлева',
    dt: null,
    userm_id: 12,
    userm: 'П.В. Яковлева',
    dtm: null
  }
]


// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/contacts.ts